export { default as load } from './cldr/load';
export { default as setData } from './cldr/set-data';
export { default as dateFieldName } from './cldr/date-field-name';
export { default as dateFormatNames } from './cldr/date-format-names';
export { cldr, localeInfo } from './cldr/info';
export { currencyDisplays, currencyDisplay, currencyFractionOptions, territoryCurrencyCode, localeCurrency } from './cldr/currency';
export { default as firstDay } from './cldr/first-day';
export { default as numberSymbols } from './cldr/number-symbols';


//# sourceMappingURL=cldr.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/cldr.js
// module id = ../../../../@telerik/kendo-intl/dist/es/cldr.js
// module chunks = 3